import React, { useRef, useState } from "react";
import { Dropdown, Popover, Whisper } from "rsuite";

type Props = {
  options: {
    icon?: React.ReactElement<any>;
    label: string;
    value: string;
    labelWidth?: number;
  }[];
  onSelect: React.EventHandler<any>;
  children:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | ((
        props: any,
        ref: any
      ) => React.ReactElement<any, string | React.JSXElementConstructor<any>>);
};
export const MenuOptions = (props: Props) => {
  const { options } = props;
  const popOverRef = useRef<any>(null);
  const whisperRef = useRef<any>(null);


  const handleClick = (e: any) => {
    whisperRef.current.close();

    props.onSelect(e);
  };
  const speaker = (props: any, ref: any) => {
    const { left, top, className } = props;
    return (
      <Popover ref={ref} style={{ left, top }} className={className} full>
        <Dropdown.Menu onSelect={handleClick}>
          {options.map((option) => (
            <Dropdown.Item
              className="flex justify-center items-center gap-2"
              key={option.value}
              icon={option.icon}
              eventKey={option.value}
            >
              {option.labelWidth ? (
                <div className={`w-${option.labelWidth} font-medium`} h-2>
                  {option.label}
                </div>
              ) : (
                <div className="w-16">{option.label}</div>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Popover>
    );
  };
  return (
    <div ref={popOverRef} style={{ position: "relative", cursor: "pointer" }}>
      <Whisper
        container={() => popOverRef.current}
        ref={whisperRef}
        trigger="click"
        placement="bottomEnd"
        speaker={speaker}
      >
        {props.children}
      </Whisper>
    </div>
  );
};
